import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTrackAssetContext } from '../../components/TrackAsset';
import { block } from '../../utils';
import FramingAdjustmentHandles from './FramingAdjustmentHandles';
import FramingSegment from './FramingSegment';
import { useFramingTimelineContext } from './FramingTimelineContext';
import { createLayoutTimelineSegmentIdsSelector } from './selectors';

export type FramingTimelineContentsProps = {};

const FramingTimelineContents = () => {
  const { offsetPx } = useFramingTimelineContext();
  const { id: videoId } = useTrackAssetContext();

  const timeline = useSelector(createLayoutTimelineSegmentIdsSelector(videoId));

  const [activeHandleGapIndex, setActiveHandleGapIndex] = useState<number>();

  const handleDragStart = useCallback((gapIndex: number) => {
    setActiveHandleGapIndex(gapIndex);
  }, []);

  const handleDragStop = useCallback(() => {
    setActiveHandleGapIndex(undefined);
  }, []);

  return (
    // the framing timeline is drawn relative to the video asset. this outer container
    // "saves space" for the asset and should be invisible
    <div className={block('autoframed-video-asset-framing-timeline')}>
      <div
        className={block('autoframed-video-asset-framing-timeline-inner')}
        style={{
          left: offsetPx,
        }}
      >
        {timeline.map((segmentId, index) => (
          <FramingSegment
            id={segmentId}
            isActive={
              index === activeHandleGapIndex ||
              index === activeHandleGapIndex - 1
            }
            key={segmentId}
          />
        ))}
        <FramingAdjustmentHandles
          onDragStart={handleDragStart}
          onDragStop={handleDragStop}
        />
      </div>
    </div>
  );
};

export default FramingTimelineContents;
